import { InMemoryCache, makeVar } from '@apollo/client';
import { CustomError, StepInfo, LitePurchaseIntent, User } from 'apollo/types';
import { ProcedureInfo } from 'utils/proceduresInfo';
import steps from 'utils/stepsInfo';

export const useMocksCache = makeVar<boolean>(false);
export const isMobileLayoutCache = makeVar<boolean>(false);
export const isAppLoading = makeVar<boolean>(false);
export const isStylesConfigurationLoading = makeVar<boolean>(false);
export const analyticsApiKeY = makeVar<string>('');

export const purchaseIntentToken = makeVar<string | null>(null);
export const selectedPurchaseIntent = makeVar<LitePurchaseIntent | null>(null);

export const concessionaireName = makeVar<string>('');
export const concessionaireLogoUrl = makeVar<string | null>(null);
export const concessionaireUrl = makeVar<string>('');

export const stepList = makeVar<StepInfo[]>(steps);
export const currentSubStep = makeVar<number>(-1);
export const userData = makeVar<User | null>(null);

export const logged = makeVar<boolean | string>(false);
export const showLoginForm = makeVar<boolean>(false);
export const showMailValidationModal = makeVar<boolean>(false);
export const customerSession = makeVar<string | null>(null);

export const showErrorModal = makeVar<boolean>(false);
export const errorData = makeVar<CustomError | null>(null);
export const errorList = makeVar<CustomError[]>([]);
export const selectedProcedures = makeVar<ProcedureInfo[]>([]);
export const selectedProceduresTotalCost = makeVar<number | null>(null);

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        useMocksCache: {
          read() {
            return useMocksCache();
          },
        },
        showErrorModal: {
          read() {
            return showErrorModal();
          },
        },
        errorData: {
          read() {
            return errorData();
          },
        },
      },
    },
  },
});

export default cache;
